import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  const globalStore = useGlobalStore();
  const interactiveStore = useInteractiveStore();
  if (interactiveStore.isPageSpeedBot) return;
  const copyProtection = (flag: number) => {
    if (globalStore.seoData?.page?.component !== 'model') {
      return;
    }
    const slug = globalStore.seoData?.slug || '';
    const eventListenerFunction = () => {
      const textForAdd = `<br />Подробнее: https://price.ru/${slug}`;
      const textTarget = window.getSelection();
      const textResultForCopy = textTarget + textForAdd;
      const hiddenElement = document.createElement('div');
      hiddenElement.style.position = 'absolute';
      hiddenElement.style.left = '-98769px';
      document.body.appendChild(hiddenElement);
      hiddenElement.innerHTML = textResultForCopy;
      if (textTarget) textTarget.selectAllChildren(hiddenElement);
      window.setTimeout(function () {
        document.body.removeChild(hiddenElement);
      }, 100);
    };

    const elements = document.querySelectorAll('[data-copy="for-copied"]');
    const isElements = elements && elements.forEach instanceof Function;
    if (!isElements) return;
    if (flag === 1) {
      elements.forEach((element) => {
        if (element.getAttribute('listener') === 'true') {
          return;
        }
        element.setAttribute('listener', 'true');
        element.addEventListener('copy', eventListenerFunction);
      });
      return;
    }

    elements.forEach((element) => {
      element.setAttribute('listener', 'false');
      element.removeEventListener('copy', eventListenerFunction);
    });
  };
  return {
    provide: {
      copyProtection,
    },
  };
});
